
import { PlaybackKey } from '../../types';

export const playback: Record<PlaybackKey, string> = {
  autoPlay: 'Auto Play',
  showControls: 'Show Controls',
  showProgressBar: 'Show Progress Bar',
  loopVideo: 'Loop Video',
  playbackSpeed: 'Playback Speed',
  current: 'Current',
  disableControls: 'Disable Controls',
  largePlayer: 'Large Player',
  skipForward: 'Skip Forward',
  rewind: 'Rewind',
  showCurrentTime: 'Show Current Time',
  smallPlayButton: 'Small Play Button',
  fullScreen: 'Fullscreen',
  volumeControl: 'Volume Control',
  controlsColor: 'Controls Color',
  playIcon: 'Play Icon',
  progressBarHeight: 'Progress Bar Height',
  progressBarColor: 'Progress Bar Color',
  progressBarPreview: 'Progress Bar Preview',
  progressBarSettings: 'Progress Bar Settings',
  progressBarInfo: 'Shows a progress bar at the bottom of the video',
  autoRepeat: 'Auto Repeat',
  autoRepeatInfo: 'Automatically restarts the video when it ends.',
  loop: 'Loop',
};
